export default __webpack_public_path__ + "static/pp-capace-3ee38223a8b8b14d2de28b8423fc04ad.jpg";